// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9wVCP","contentContainer":"styles_contentContainer__gYdIH","mainImage":"styles_mainImage__wgWM+"};